<template>
  <div>
    <Toaster position="bottom-right" :timeout="4000" />
    <div class="flex flex-col h-dvh">
      <header
        class="sticky flex-shrink-0 bg-background top-0 left-0 z-50 w-full px-6 lg_px-12 flex items-center justify-between border-b h-20"
      >
        <a href="/">
          <div class="flex text-dark">
            <VRIFYLogo class="w-32" />
          </div>
        </a>

        <Button v-if="!userState.loading && !userState.user && notOnLoginPage" :as="NuxtLink" variant="secondary" to="/login">Login</Button>
      </header>

      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { NuxtLink } from '#components'
import Toaster from '~/components/ui/toast/Toaster.vue'
import VRIFYLogo from '~/assets/icons/VRIFYLogo.vue'

const { state: userState } = useUser()

useHead({
  titleTemplate: title => (title ? `${title} - VRIFY` : 'VRIFY'),
})

const notOnLoginPage = computed(() => {
  const currentPath = useRoute().path
  return !currentPath.includes('login') && !currentPath.includes('forgot-password')
})
</script>

<style>
@import '@/assets/css/admin.css';
</style>
